import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import InfiniteScroll from "react-infinite-scroller";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import CloseIcon from "@material-ui/icons/Close";
import { Scrollbars } from "react-custom-scrollbars";
import { findProviderService, downloadMedia } from "__helpers/util";

import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import {
  IconButton,
  Link as MaterialLink,
  LinearProgress,
  CircularProgress,
  TextField,
  Button,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
} from "@material-ui/core";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import DateFnsUtils from "@date-io/date-fns";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import notesArrow from "assets/img/icons/notes-arrow.svg";
import { connect } from "react-redux";
import { reduxLoad } from "js/actions/index";
import { userService } from "_services/user.service";
import {
  REFERRAL_TYPE,
  ALLOWED_PROFILE_IMAGE_SIZE,
  ALLOWED_FACESHEET_EXTENTION,
  MAX_INPUT_LENGTH_LONG,
  EMAIL_REGEX,
} from "__helpers/constants";
import PatientCriteria from "views/dpViews/SinglePatientDetail/PatientCriteria";

import { FormErrors } from "../../components/Login/FormErrors";

import fileExtension from "file-extension";
import enMsg from "__helpers/locale/en/en";
import ChatComment from "components/Comments/ChatComment";
import PatientNotes from "views/dpViews/SinglePatientDetail/PatientNotes";
import TransportDetails from "./TransportDetails";
import PatientTaskListClass from "views/dpViews/SinglePatientDetail/PatientTaskList";
import ImageViewer from "./ImageViewer";
import ProviderProfilePanel from "./ProviderProfilePanel";
import { width } from "@material-ui/system";

function mapDispatchToProps(dispatch) {
  return {
    reduxLoad: (reduxLoadVal) => dispatch(reduxLoad(reduxLoadVal)),
  };
}
const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const tooltipStyles = {
  tooltip: {
    width: "auto !important",
    // height: "36px",
    borderRadius: "18px",
    boxShadow: "0 20px 80px 0",
  },
};
const CustomTooltip = withStyles(tooltipStyles)(Tooltip);

class FinalizedProviderTabPanelClass extends React.Component {
  inputOpenFileRef = React.createRef(null);
  constructor(props) {
    super(props);
    this.dateUtility = new DateFnsUtils();
    let totalCategory = {
      1: {
        mainCategory: [],
        subCategory: [],
        childCategory: [],
      },
      2: {
        mainCategory: [],
        subCategory: [],
        childCategory: [],
      },
      3: {
        mainCategory: [],
        subCategory: [],
        childCategory: [],
      },
      4: {
        mainCategory: [],
        subCategory: [],
        childCategory: [],
      },
      5: {
        mainCategory: [],
        subCategory: [],
        childCategory: [],
      },
    };
    if (this.props.categoryListRedux) {
      if (this.props.categoryListRedux && this.props.categoryListRedux.length) {
        this.props.categoryListRedux.map((cList, key) => {
          // main loop
          if (cList.catagoryId == 1) {
            const { children } = cList;
            children.map((mChildren, mKey) => {
              if (mChildren.children && mChildren.children.length) {
                mChildren.children.map((cChildren, cKey) => {
                  totalCategory[1].childCategory.push(cChildren.catagoryId);
                });
              } else {
                totalCategory[1].subCategory.push(mChildren.catagoryId);
              }
            });
          }
          if (cList.catagoryId == 2) {
            const { children } = cList;
            children.map((mChildren, mKey) => {
              if (mChildren.children && mChildren.children.length) {
                mChildren.children.map((cChildren, cKey) => {
                  totalCategory[2].childCategory.push(cChildren.catagoryId);
                });
              } else {
                totalCategory[2].subCategory.push(mChildren.catagoryId);
              }
            });
          }
          if (cList.catagoryId == 3) {
            const { children } = cList;
            children.map((mChildren, mKey) => {
              if (mChildren.children && mChildren.children.length) {
                mChildren.children.map((cChildren, cKey) => {
                  totalCategory[3].childCategory.push(cChildren.catagoryId);
                });
              } else {
                totalCategory[3].subCategory.push(mChildren.catagoryId);
              }
            });
          }
          if (cList.catagoryId == 4) {
            const { children } = cList;
            children.map((mChildren, mKey) => {
              if (mChildren.children && mChildren.children.length) {
                mChildren.children.map((cChildren, cKey) => {
                  totalCategory[4].childCategory.push(cChildren.catagoryId);
                });
              } else {
                totalCategory[4].subCategory.push(mChildren.catagoryId);
              }
            });
          }
          if (cList.catagoryId == 5) {
            const { children } = cList;
            children.map((mChildren, mKey) => {
              if (mChildren.children && mChildren.children.length) {
                mChildren.children.map((cChildren, cKey) => {
                  totalCategory[5].childCategory.push(cChildren.catagoryId);
                });
              } else {
                totalCategory[5].subCategory.push(mChildren.catagoryId);
              }
            });
          }
        });
      }
    }
    let spinner = document.getElementById("loadingSpinner");
    this.state = {
      loading: false,
      isCatAvailable: [],
      refferalProviderEntity: [],
      refferalPatientEntity: [],
      providerData: {},
      page: 1,
      searchKeyword: "",
      providerIds: [],
      spinner: spinner,
      size: 10,
      refferalId: this.props.refferalId ? this.props.refferalId : "",
      patientId: JSON.parse(localStorage.getItem("_selected_patient_list")),
      fetchMore: false,
      categoryId: this.props.categoryId,
      selectedCategoryId: this.props.categoryId,
      totalPatients: 0,
      providerStatus: null,
      categoryList: props.categoryListRedux ? props.categoryListRedux : [],
      insuranceList: props.insuranceListRedux ? props.insuranceListRedux : [],
      totalCategoryIds: totalCategory,
      providerIdForStatusChange: "",
      providerReferralStatusId: "",
      patientInfo: this.props.patientInfo ? this.props.patientInfo : {},
      patientCriteriaModalStatus: false,
      comment: "",
      formErrors: {
        comment: "",
        file: "",
        sendToEmail: "",
      },
      providerDetail: [],
      providerDetailModalStatus: false,
      sendToEmail: "",
      sendToEmailValid: false,
      fileName: "",
      file: "",
      fileBlob: "",
      receiverId: "",
      fileValid: false,
      commentValid: false,
      openConfirmationBox: false,
      commentsThread: [],
      owlCarouselOptions: {
        loop: false,
        dots: false,
        margin: 0,
        nav: true,
        stagePadding: 1,
        items: 6,
        navText: [
          "<i class='fa fa-chevron-left'></i>",
          "<i class='fa fa-chevron-right'></i>",
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          576: {
            items: 3,
          },
          768: {
            items: 4,
          },
          850: {
            items: 2,
          },
          1100: {
            items: 3,
          },
          1200: {
            items: 3,
          },
          1400: {
            items: 4,
          },
          1600: {
            items: 5,
          },
          1800: {
            items: 6,
          },
        },
        patientNotesStatus: false,
      },
      referralPatientModal: false,
      refferalStatus: 3,
      transportDetailsModal: false,
      imageViewerOpen: false,
      imageViewerImages: [],
      imageViewerIndex: 0,
      profilePanelOpen: false,
      profileProviderData: null,
      organizationDetails: {}, // Store fetched org details keyed by providerId
    };
    this.searchProvider = this.searchProvider.bind(this);
    this.fetchOrganizationDetails = this.fetchOrganizationDetails.bind(this);
    this.selectProviderCheckBox = this.selectProviderCheckBox.bind(this);
    this.selectProviderStatus = this.selectProviderStatus.bind(this);
    this.rescindReferral = this.rescindReferral.bind(this);
    this.patientCriteriaModalOpen = this.patientCriteriaModalOpen.bind(this);
    this.patientCriteriaModalClose = this.patientCriteriaModalClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.rescindReferralConfirmation = this.rescindReferralConfirmation.bind(
      this,
    );
    this.handleConfirmBox = this.handleConfirmBox.bind(this);
    this.patientNotesOpen = this.patientNotesOpen.bind(this);
    this.viewReferralPatients = this.viewReferralPatients.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.handleDownloadBrochure = this.handleDownloadBrochure.bind(this);
    this.providerDetailModal = this.providerDetailModal.bind(this);
  }

  handleImageClick(pictures, index) {
    this.setState({
      imageViewerOpen: true,
      imageViewerImages: pictures,
      imageViewerIndex: index,
    });
  }

  handleDownloadBrochure(orgData) {
    if (!orgData || !orgData.organizationBrochureBase64) return;
    const base64 = orgData.organizationBrochureBase64;
    let fileName = "Organization_Brochure.pdf";
    if (base64.startsWith("data:")) {
      const mimeType = base64.split(";")[0].split(":")[1];
      const extMap = {
        "image/jpeg": ".jpg",
        "image/png": ".png",
        "image/gif": ".gif",
        "image/svg+xml": ".svg",
        "application/pdf": ".pdf",
      };
      const ext = extMap[mimeType] || ".pdf";
      fileName = "Organization_Brochure" + ext;
    }
    const link = document.createElement("a");
    link.href = base64;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async fetchOrganizationDetails(providerId) {
    try {
      const response = await fetch(
        apiPath.organizationDetailsByProviderId + "?id=" + providerId,
        {
          method: "GET",
          headers: generalAuthTokenHeader(),
        },
      );
      if (response.ok) {
        const data = await response.json();
        this.setState((prevState) => ({
          organizationDetails: {
            ...prevState.organizationDetails,
            [providerId]: data,
          },
        }));
      }
    } catch (error) {
      console.error("Failed to fetch organization details:", error);
    }
  }

  async fetchProviders() {
    let url;
    url = apiPath.findAwaitingProvider + "?refferalId=" + this.state.refferalId;
    this.setState({
      loading: true,
    });
    this.props.loaderStatus(true);
    const response = await fetch(url, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
        } else if (response.ok) {
          let totalPatientCount = response.headers.get("X-Total-Count");
          this.setState({
            totalPatients: totalPatientCount,
          });
        } else if (response.status === 401) {
        } else {
        }
        return response.json();
      })
      .then((data) => {
        if (data && data[0]) {
          data = data[0];
          if (data && data.refferalId) {
            if (this.state.refferalStatus != data.refferalStatus) {
              this.props.updatePatient();
              return false;
            }
            let refferalProviderEntity = [];
            let refferalPatientEntity = [];
            let receiverId = "";
            if (
              data.refferalProviderEntity &&
              data.refferalProviderEntity.length
            ) {
              refferalProviderEntity = data.refferalProviderEntity;
              refferalProviderEntity.map((listItem, index) => {
                if (listItem.providerStatusId === 3) {
                  receiverId = listItem.providerId;
                }
              });
            }
            if (
              data.refferalPatientEntity &&
              data.refferalPatientEntity.length
            ) {
              refferalPatientEntity = data.refferalPatientEntity;
            }
            this.setState(
              {
                refferalProviderEntity: refferalProviderEntity,
                refferalPatientEntity: refferalPatientEntity,
                providerData: data,
                receiverId: receiverId,
              },
              () => {
                this.fetchComments();
                // Fetch org details for finalized provider
                refferalProviderEntity.forEach((item) => {
                  if (item.providerStatusId === 3) {
                    this.fetchOrganizationDetails(item.providerId);
                  }
                });
              },
            );
          }
        }
        this.setState({
          loading: false,
        });
        this.props.loaderStatus(false);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        this.props.loaderStatus(false);
        return response;
      });
  }
  componentDidMount() {
    this.fetchProviders();
  }
  componentDidUpdate() {
    if (
      this.props.reduxLoadFlag != undefined &&
      this.state.reduxLoadFlag != this.props.reduxLoadFlag
    ) {
      let categoryList = [];
      let insuranceList = [];
      let hospitalList = [];
      let patientStatusList = [];
      let userInfo = {};
      let totalCategory = {
        1: {
          mainCategory: [],
          subCategory: [],
          childCategory: [],
        },
        2: {
          mainCategory: [],
          subCategory: [],
          childCategory: [],
        },
        3: {
          mainCategory: [],
          subCategory: [],
          childCategory: [],
        },
        4: {
          mainCategory: [],
          subCategory: [],
          childCategory: [],
        },
        5: {
          mainCategory: [],
          subCategory: [],
          childCategory: [],
        },
      };
      if (this.props.categoryListRedux) {
        let selectedcategoryList = this.props.categoryListRedux;
        categoryList = selectedcategoryList ? selectedcategoryList : [];

        if (categoryList && categoryList.length) {
          categoryList.map((cList, key) => {
            // main loop
            if (cList.catagoryId == 1) {
              const { children } = cList;
              children.map((mChildren, mKey) => {
                if (mChildren.children && mChildren.children.length) {
                  mChildren.children.map((cChildren, cKey) => {
                    totalCategory[1].childCategory.push(cChildren.catagoryId);
                  });
                } else {
                  totalCategory[1].subCategory.push(mChildren.catagoryId);
                }
              });
            }
            if (cList.catagoryId == 2) {
              const { children } = cList;
              children.map((mChildren, mKey) => {
                if (mChildren.children && mChildren.children.length) {
                  mChildren.children.map((cChildren, cKey) => {
                    totalCategory[2].childCategory.push(cChildren.catagoryId);
                  });
                } else {
                  totalCategory[2].subCategory.push(mChildren.catagoryId);
                }
              });
            }
            if (cList.catagoryId == 3) {
              const { children } = cList;
              children.map((mChildren, mKey) => {
                if (mChildren.children && mChildren.children.length) {
                  mChildren.children.map((cChildren, cKey) => {
                    totalCategory[3].childCategory.push(cChildren.catagoryId);
                  });
                } else {
                  totalCategory[3].subCategory.push(mChildren.catagoryId);
                }
              });
            }
            if (cList.catagoryId == 4) {
              const { children } = cList;
              children.map((mChildren, mKey) => {
                if (mChildren.children && mChildren.children.length) {
                  mChildren.children.map((cChildren, cKey) => {
                    totalCategory[4].childCategory.push(cChildren.catagoryId);
                  });
                } else {
                  totalCategory[4].subCategory.push(mChildren.catagoryId);
                }
              });
            }
            if (cList.catagoryId == 5) {
              const { children } = cList;
              children.map((mChildren, mKey) => {
                if (mChildren.children && mChildren.children.length) {
                  mChildren.children.map((cChildren, cKey) => {
                    totalCategory[5].childCategory.push(cChildren.catagoryId);
                  });
                } else {
                  totalCategory[5].subCategory.push(mChildren.catagoryId);
                }
              });
            }
          });
        }
      }
      if (this.props.insuranceListRedux) {
        let selectedinsuranceList = this.props.insuranceListRedux;
        insuranceList = selectedinsuranceList ? selectedinsuranceList : [];
      }
      if (this.props.hospitalListRedux) {
        let selectedhospitalList = this.props.hospitalListRedux;
        hospitalList = selectedhospitalList ? selectedhospitalList : [];
      }
      if (this.props.patientStatusListRedux) {
        let selectedpatientStatusList = this.props.patientStatusListRedux;
        patientStatusList = selectedpatientStatusList
          ? selectedpatientStatusList
          : [];
      }
      if (this.props.userInfoRedux) {
        let userInfoRedux = this.props.userInfoRedux;
        userInfo = userInfoRedux ? userInfoRedux : {};
      }
      this.setState({
        reduxLoadFlag: this.props.reduxLoadFlag,
        categoryList: categoryList,
        insuranceList: insuranceList,
        hospitalList: hospitalList,
        patientStatusList: patientStatusList,
        userInfo: userInfo,
        totalCategoryIds: totalCategory,
      });
    }
  }
  componentWillUnmount() {
    this.subscription = findProviderService.clearFindProvidersList();
  }
  fetchMoreData = () => {
    setTimeout(() => {
      if (this.state.fetchMore) {
        this.setState({
          page: this.state.page + 1,
        });
      }
    }, 2500);
  };
  searchProvider = (event) => {
    let allProviderList =
      this.state.providerData && this.state.providerData.refferalProviderEntity
        ? this.state.providerData.refferalProviderEntity
        : [];
    const searchText = event.target.value.trim();
    let allLocalProviderList = [];
    if (searchText) {
      allProviderList = allProviderList.filter((v, i) => {
        if (v.provider && v.provider.providerName) {
          return (
            v.provider.providerName
              .toLowerCase()
              .indexOf(searchText.toLowerCase().trim()) !== -1
          );
        }
      });
      this.setState({
        refferalProviderEntity: allProviderList,
      });
    }
    this.setState({
      refferalProviderEntity: allProviderList,
    });
  };
  getProviderId = (providerId) => {
    let providerIds = this.state.providerIds;
    let allItem = this.state.items;
    if (providerIds.includes(providerId)) {
      const index = providerIds.indexOf(providerId);
      if (index > -1) {
        providerIds.splice(index, 1);
        allItem.map((item) => {
          if (item.id == providerId) item["isChecked"] = false;
        });
      }
    } else {
      allItem.map((item) => {
        if (item.id == providerId) item["isChecked"] = true;
      });
      providerIds.push(providerId);
    }
    this.setState({
      providerIds: providerIds,
    });
  };
  providerStatusDropdown = (event, providerID, referralStatusId) => {
    this.setState({
      providerStatus: event.currentTarget,
      providerIdForStatusChange: providerID,
      providerReferralStatusId: referralStatusId,
    });
  };
  handleCloseForProviderStatus = () => {
    this.setState({
      providerStatus: null,
    });
  };
  selectProviderCheckBox(providerId) {
    this.props.selectedProviderDataCallback(providerId);
  }
  async rescindReferral() {
    let showNotification = "";
    let data = {};
    this.setState({
      loading: true,
      openConfirmationBox: false,
    });
    this.props.loaderStatus(true);
    let url =
      apiPath.rescindReferralDp + "?refferalId=" + this.state.refferalId;
    const response = await fetch(url, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Rescind Status",
            message: "Bad response from server",
            type: "danger",
          };
          this.props.loaderStatus(false);
        } else if (response.ok) {
          showNotification = {
            title: "Rescind Status",
            message: "Rescinded all providers successfull",
            type: "success",
          };
          this.props.updatePatient();
        } else {
          showNotification = {
            title: "Rescind Status",
            message: "Bad response from server.",
            type: "danger",
          };
          this.props.loaderStatus(false);
        }
        this.setState({
          loading: false,
        });
        return response.json();
      })
      .then((data) => {
        if (data.title) {
          showNotification = {
            title: "Rescind Status",
            message: data.title,
            type: "danger",
          };
        }
        userService.showNotification(showNotification);
        return true;
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        this.props.loaderStatus(false);
      });
  }
  rescindReferralConfirmation() {
    this.setState({
      openConfirmationBox: true,
    });
  }
  handleConfirmBox() {
    this.setState({
      openConfirmationBox: false,
      referralPatientModal: false,
    });
  }
  async selectProviderStatus(event) {
    if (this.state.providerReferralStatusId == event.target.value) {
      this.handleCloseForProviderStatus();
      return true;
    }
    this.state.spinner.removeAttribute("hidden", "true");
    let showNotification = "";
    let data = {
      providerId: this.state.providerIdForStatusChange,
      refferalId: this.state.refferalId,
      statusId: event.target.value,
    };
    const response = await fetch(apiPath.changeProviderStatus, {
      method: "PUT",
      headers: generalAuthTokenHeader(),
      body: JSON.stringify(data),
      data: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Provider Status",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: "Provider Status",
            message: "Bad response from server.",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        this.fetchProviders();
        this.handleCloseForProviderStatus();
        showNotification = {
          title: "Provider Status",
          message: "Provider status change successfully.",
          type: "success",
        };
        return true;
      })
      .catch((error) => {
        showNotification = {
          title: "Provider Status",
          message: "Something went wrong.Please try after sometime..",
          type: "danger",
        };
      });
    this.state.spinner.setAttribute("hidden", "true");
    userService.showNotification(showNotification);
  }
  patientCriteriaModalOpen = () => {
    this.setState({
      patientCriteriaModalStatus: true,
    });
  };
  patientCriteriaModalClose = () => {
    this.setState({
      patientCriteriaModalStatus: false,
    });
  };
  searchReturn(event) {
    if (event.target.keyCode === 13 || event.key === "Enter") {
      event.preventDefault();
    }
  }
  setFilterProviderList = (filter) => {
    // do nothing
  };
  handleChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      },
    );
  };
  validateField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let commentValid = this.state.commentValid;
    switch (fieldName) {
      case "comment":
        let commentErr = "";
        if (fieldValue.trim().length == 0) {
          commentValid = false;
          commentErr = "Comment is required";
        } else if (fieldValue.trim().length > MAX_INPUT_LENGTH_LONG) {
          commentValid = false;
          commentErr = "Comment length cannot exceed 255 characters";
        } else {
          commentValid = true;
          commentErr = "";
        }
        // commentValid = fieldValue.trim().length > 0;
        fieldValidationErrors.comment = commentErr;
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        commentValid: commentValid,
      },
      this.validateForm,
    );
  };
  validateForm() {
    return this.state.commentValid || this.state.fileValid;
  }
  fetchComments = () => {};
  onFileBrowse = (event) => {
    this.inputOpenFileRef.current.click();
  };
  async handleSubmit(event) {
    event.preventDefault();
    let data = {
      base64Data: this.state.file,
      description: this.state.comment,
      fileName: this.state.fileName,
      receiverId: this.state.providerData.refferalProviderEntity[0]
        ? this.state.providerData.refferalProviderEntity[0].providerId
        : "",
      refferalId: this.state.providerData.refferalProviderEntity[0]
        ? this.state.providerData.refferalProviderEntity[0].refferalId
        : "",
    };
    this.setState({ loading: true });
    let showNotification = {};
    let modalCloseStatus = 1;
    const response = await fetch(apiPath.postCommentByDP, {
      method: "POST",
      headers: generalAuthTokenHeader(),
      body: JSON.stringify(data),
      data: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Comment",
            message: enMsg.badResponseFromServer,
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: "Comment",
            message: enMsg.badResponseFromServer,
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data.id) {
          this.fetchComments();
          this.setState({
            comment: "",
            fileName: "",
            file: "",
            commentValid: false,
            fileValid: false,
          });
          showNotification = {
            title: "Comment",
            message: "Message has been sent to the provider",
            type: "success",
          };
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Comment",
          message: enMsg.clientSideError,
          type: "danger",
        };
      });
    userService.showNotification(showNotification);
    this.setState({ loading: false });
  }
  handleSelectedFile = (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (typeof file === "undefined" && this.state.fileName == "") {
      this.setState({
        commentValid: false,
        fileValid: false,
      });
      return;
    }
    let fieldValidationErrors = this.state.formErrors;
    let error = "";
    let fileValid = false;
    if (typeof file == "object" && file.size > ALLOWED_PROFILE_IMAGE_SIZE) {
      error = enMsg.allowedFaceSheetSize;
    } else if (
      typeof file == "object" &&
      !ALLOWED_FACESHEET_EXTENTION.includes(file.type)
    ) {
      error = enMsg.allowedFaceSheetType;
    } else {
      fileValid = true;
    }

    if (typeof file !== undefined && fileValid) {
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        let result = fileReader.result;
        this.setState({
          fileName: file.name,
          file: result,
        });
        this.fileBlob = file;
        this.filename = new Date().getTime() + "." + fileExtension(file.name);
      });
      if (file) {
        fileReader.readAsDataURL(file);
      }
    }
    if (!fileValid) {
      this.setState({
        fileName: "",
      });
    }

    fieldValidationErrors.file = fileValid ? "" : error;
    this.setState(
      {
        fileValid: fileValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm,
    );
  };

  downloadFileFax = async (fileName, fileUrl) => {
    let showNotification = {};
    try {
      let showNotification = {
        title: "Fax Details",
        message: "Please wait, Downloading Fax files",
        type: "info",
      };
      userService.showNotification(showNotification);
      let urlArr = fileUrl.split("/");
      let urlArrEndPoint =
        urlArr[urlArr.length - 2] + "/" + urlArr[urlArr.length - 1];
      let dataUses = "";
      dataUses = "?key=" + urlArrEndPoint;
      let sheetData = await userService.fetchCommentSheetsData(
        apiPath.downloadCommentFile + dataUses,
        fileName,
      );
    } catch (error) {
      showNotification = {
        title: "Fax",
        message: "No Fax available.",
        type: "danger",
      };
      userService.showNotification(showNotification);
    }
    this.setState({
      loading: false,
    });
    return false;
  };

  downloadFile = async (fileName, fileUrl) => {
    this.setState({
      loading: true,
    });
    let showNotification = {};
    try {
      downloadMedia(fileUrl, fileName);
    } catch (error) {
      showNotification = {
        title: "Facesheet",
        message: "No facesheet available.",
        type: "danger",
      };
      userService.showNotification(showNotification);
    }
    this.setState({
      loading: false,
    });
    return false;
  };
  patientNotesOpen() {
    let notesStatus = this.state.patientNotesStatus ? false : true;
    this.setState({
      patientNotesStatus: notesStatus,
    });
  }
  viewReferralPatients() {
    this.setState({
      referralPatientModal: true,
    });
  }
  toggleTransportDetailsModal = () => {
    const transportDetailsModal = this.state.transportDetailsModal;

    this.setState({
      transportDetailsModal: !transportDetailsModal,
    });
  };

  providerDetailModal(providerData) {
    this.setState({
      profilePanelOpen: true,
      profileProviderData: providerData,
    });
  }

  render() {
    const {
      refferalProviderEntity,
      refferalPatientEntity,
      providerData,
      loading,
      provider,
      isCatAvailable,
      selectedCategoryId,
      totalCategoryIds,
    } = this.state;
    let availableCatUser = [];
    return (
      <>
        {/* Image Viewer Modal */}
        <ImageViewer
          open={this.state.imageViewerOpen}
          images={this.state.imageViewerImages}
          initialIndex={this.state.imageViewerIndex}
          onClose={() => this.setState({ imageViewerOpen: false })}
        />

        {/* Provider Profile Side Panel */}
        <ProviderProfilePanel
          open={this.state.profilePanelOpen}
          providerData={this.state.profileProviderData}
          categoryId={this.state.categoryId}
          totalCategoryIds={totalCategoryIds}
          onClose={() => this.setState({ profilePanelOpen: false, profileProviderData: null })}
          onImageClick={(images, index) =>
            this.setState({
              imageViewerOpen: true,
              imageViewerImages: images,
              imageViewerIndex: index,
            })
          }
        />

        {this.state.categoryId && (
          <PatientCriteria
            modalStatus={this.state.patientCriteriaModalStatus}
            modalClose={this.patientCriteriaModalClose}
            selectCategoryId={this.state.categoryId}
            patientId={this.state.patientId}
            patientInfo={this.state.patientInfo}
            setFilterProviderList={this.setFilterProviderList}
            readOnly={true}
          />
        )}
        <PatientTaskListClass
          modalStatus={this.state.patientTaskModalStatus}
          modalClose={this.patientTaskModalClose}
          selectCategoryId={this.state.categoryId}
          patientId={this.state.patientId}
          patientInfo={this.state.patientInfo}
          setFilterProviderList={this.setFilterProviderList}
          readOnly={true}
        />
        <PatientNotes
          modalStatus={this.state.patientNotesStatus}
          // modalClose={this.patientNotesClose()}
          selectCategoryId={this.state.categoryId}
          patientInfo={this.state.patientInfo}
        />
        <Dialog
          open={this.state.openConfirmationBox}
          maxWidth={"xs"}
          onClose={this.handleConfirmBox}
          TransitionComponent={Transition}
          aria-labelledby="form-dialog-title"
          className="add-modal front-modal "
        >
          <DialogTitle className="add-modal-title" id="form-dialog-title">
            Rescind Referral
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.handleCloseForProviderStatus}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              width={1}
              display="flex"
              justifyContent="flex-start"
              mb={1}
              mt={1}
            >
              <Box pr={2}>Do you want rescind this referral ?</Box>
            </Box>
          </DialogContent>
          <DialogActions className="modal-actions" justify="center">
            <Button
              type="button"
              className="btn1"
              onClick={this.rescindReferral}
            >
              Confirm
            </Button>
            <Button onClick={this.handleConfirmBox} className="cancel-link">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.referralPatientModal}
          maxWidth={"sm"}
          onClose={this.handleConfirmBox}
          TransitionComponent={Transition}
          aria-labelledby="form-dialog-title"
          className="add-modal front-modal ViewInvitemodal"
        >
          <DialogTitle className="add-modal-title " id="form-dialog-title">
            Referral Patients
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.handleConfirmBox}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              display="flex"
              flexDirection="column"
              width={1}
              className="patient-list-page AwaitingProviderTabPanelCSS patient-list-page-new patient-info-page-new  FinalisedTab ViewInvite"
            >
              <Box display="flex" pr={2} className="divcontainer-tab " mb={2}>
                <Box pr={1} className="title-box">
                  <h4 className="label">Referral ID</h4>
                  <h4 className="value">{this.state.refferalId}</h4>
                </Box>
                <Box pr={1} className="title-box">
                  <h4 className="label">Total Patients</h4>
                  <h4 className="value">
                    {refferalPatientEntity && refferalPatientEntity.length
                      ? refferalPatientEntity.length
                      : 0}
                  </h4>
                </Box>
                <Box pr={1} className="title-box">
                  <h4 className="label">Referral Sent</h4>
                  <h4 className="value">{providerData.refferalSendTime}</h4>
                </Box>
              </Box>
              <Box
                width={1}
                className="left-content-list left-content-list-New"
              >
                <div className="PatientList view-ref-cover">
                  {/* <Scrollbars style={{ height: "600px" }} universal={true} className="YOnlytScrollbars TabScroll"> */}
                  <Box
                    universal={true}
                    className="YOnlytScrollbars TabScroll min-height-threehundred"
                  >
                    {refferalPatientEntity && refferalPatientEntity.length
                      ? refferalPatientEntity.map((listItem, index) => {
                          const {
                            patientId,
                            patientEntity,
                            providerSearchHistoryEntity,
                          } = listItem;
                          let categoryId = [];
                          const urlParams = new URLSearchParams(
                            providerSearchHistoryEntity
                              ? providerSearchHistoryEntity.search
                              : "subCategoryId",
                          );
                          let subCategoryId = urlParams.get("subCategoryId");
                          subCategoryId = subCategoryId.split(",");
                          if (subCategoryId && subCategoryId[1]) {
                            categoryId = subCategoryId[1]
                              .split("-")
                              .map((item) => Number(item));
                          }
                          return (
                            <Box
                              width={1}
                              display="flex"
                              flexDirection="row"
                              mb={2}
                              pr={2}
                              key={index}
                              className="AllReferrals-page"
                            >
                              <div className="list-item-content w-100 p-right">
                                <Box
                                  className="list-item-content-data"
                                  width={1}
                                  pt={2}
                                  display="flex"
                                  flexDirection="row"
                                >
                                  <Box width={1 / 2} pr={1} className="pointer">
                                    <div className="user-info-tab-finalised">
                                      <div className="name">
                                        {patientEntity.lastName +
                                          ", " +
                                          patientEntity.firstName}
                                      </div>
                                      <div className="date-insurance">
                                        Est Discharge{" "}
                                        {
                                          patientEntity.formattedEstimatedDischargeDate
                                        }
                                      </div>
                                    </div>
                                    <div className="user-info-tab-finalised">
                                      Insurance:{" "}
                                      {this.state.insuranceList.map(
                                        (insurance) => {
                                          if (
                                            insurance.insuranceId ==
                                            patientEntity.insuranceId
                                          ) {
                                            return insurance.insuranceName;
                                          }
                                        },
                                      )}
                                    </div>
                                  </Box>
                                  <Box
                                    pl={1}
                                    width={1 / 2}
                                    className="Ref-category"
                                  >
                                    <Box
                                      width={1}
                                      display="flex"
                                      flexWrap="wrap"
                                      className=""
                                    >
                                      {this.state.categoryList &&
                                      this.state.categoryList.length &&
                                      categoryId &&
                                      categoryId.length
                                        ? this.state.categoryList.map(
                                            (cList, key) => {
                                              if (
                                                categoryId.includes(cList.id)
                                              ) {
                                                return (
                                                  <Box
                                                    width={1 / 2}
                                                    mr={1}
                                                    mb={1}
                                                    className="Ref-categorybox"
                                                    key={key}
                                                  >
                                                    {cList.categoryValue}
                                                  </Box>
                                                );
                                              }
                                            },
                                          )
                                        : null}
                                    </Box>
                                  </Box>
                                </Box>
                              </div>
                            </Box>
                          );
                        })
                      : "No Patient Found"}
                  </Box>
                </div>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <TransportDetails
          open={this.state.transportDetailsModal}
          toggle={this.toggleTransportDetailsModal}
          transportDetails={this.state.providerData.refferalTransportEntity}
        />
        <Box
          display="flex"
          flexDirection="row"
          width={1}
          className="patient-list-page AwaitingProviderTabPanelCSS gg-finalize-box patient-list-page-new patient-info-page-new withoutCheckboXContent FinalisedTab"
        >
          {providerData && providerData.refferalId ? (
            <Box  className="left-content-box">
              <div className="left-content-header">
                {/* Info Bar Row */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={2}
                  style={{
                    padding: "12px 0px",
                  }}
                >
                  {/* Left - Info boxes */}
                  <Box
                    display="flex"
                    alignItems="center"
                    style={{ gap: "12px", width: "50%" }}
                    justifyContent="space-between"
                  >
                    <Box className="title-box g-title-box w-100 text-center">
                      <h4
                        className="label"
                        style={{
                          color: "#666",
                          fontSize: "11px",
                          marginBottom: "2px",
                          margin: 0,
                          whiteSpace: "nowrap"
                        }}
                      >
                        Referral ID
                      </h4>
                      <h4
                        className="value"
                        style={{
                          color: "#333",
                          fontSize: "14px",
                          fontWeight: "600",
                          margin: 0,
                          whiteSpace: "nowrap"
                        }}
                      >
                        {this.state.refferalId}
                      </h4>
                    </Box>
                    <Box className="title-box w-100 text-center">
                      <h4
                        className="label"
                        style={{
                          color: "#666",
                          fontSize: "11px",
                          marginBottom: "2px",
                          margin: 0,
                          whiteSpace: "nowrap"
                        }}
                      >
                        Referral Type
                      </h4>
                      {providerData.faxStatus != null &&
                      providerData.faxStatus != "" ? (
                        <h4
                          className="value"
                          style={{
                            color: "#333",
                            fontSize: "14px",
                            fontWeight: "600",
                            margin: 0,
                            whiteSpace: "nowrap"
                          }}
                        >
                          FAX
                        </h4>
                      ) : (
                        <h4
                          className="value"
                          style={{
                            color: "#333",
                            fontSize: "14px",
                            fontWeight: "600",
                            margin: 0,
                          }}
                        >
                          {providerData.refferalType == "3"
                            ? "MANUAL"
                            : REFERRAL_TYPE[providerData.refferalType]}
                        </h4>
                      )}
                    </Box>
                    <Box className="title-box w-100 text-center">
                      <h4
                        className="label"
                        style={{
                          color: "#666",
                          fontSize: "11px",
                          marginBottom: "2px",
                          margin: 0,
                          whiteSpace: "nowrap"
                        }}
                      >
                        Last Referral Sent
                      </h4>
                      <h4
                        className="value"
                        style={{
                          color: "#333",
                          fontSize: "14px",
                          fontWeight: "600",
                          margin: 0,
                          whiteSpace: "nowrap"
                        }}
                      >
                        {providerData.refferalSendTime}
                      </h4>
                    </Box>
                  </Box>

                  {/* Right - Action buttons */}
                  <Box
                    display="flex"
                    alignItems="center"
                    style={{ gap: "10px" }}
                  >
                    {this.state.providerData.refferalTransportEntity && (
                      <button
                        className="pointer btn1 g-btn1"
                        onClick={() => this.toggleTransportDetailsModal()}
                      >
                        Transport Details
                      </button>
                    )}
                    {this.state.providerData.faxUploadHistory && (
                      <button
                        className="pointer btn1 g-btn1"
                        onClick={() => {
                          providerData.faxUploadHistory.forEach(
                            (faxHistory) => {
                              if (
                                faxHistory.providerId ===
                                providerData.refferalProviderEntity[0]
                                  .providerId
                              ) {
                                this.downloadFileFax(
                                  faxHistory.faxFileName,
                                  faxHistory.faxFileUrl,
                                );
                              }
                            },
                          );
                        }}
                      >
                        Fax Details
                      </button>
                    )}
                    <button
                      className="pointer btn1 g-btn1"
                      onClick={() => this.viewReferralPatients()}
                    >
                      View Referral Patients
                    </button>
                    <button
                      className="pointer g-btn1"
                      style={{
                        backgroundColor: "#F07DA8",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "8px 16px",
                        cursor: "pointer",
                      }}
                      onClick={() => this.rescindReferralConfirmation()}
                    >
                      Rescind Referral
                    </button>
                  </Box>
                </Box>
              </div>
              <Box
                width={1}
                className="left-content-list left-content-list-New"
              >
                <div className="PatientList">
                  <Scrollbars
                    // style={{ height: "calc(100vh - 460px)" }}
                    universal={true}
                    className="YOnlytScrollbars TabScroll"
                    renderView={props => (
                      <div {...props} style={{ ...props.style, marginRight: 0, paddingRight: "12px", marginBottom: 0 }} />
                    )}
                  >
                    {refferalProviderEntity && refferalProviderEntity.length ? (
                      refferalProviderEntity.map((listItem, index) => {
                        const {
                          provider,
                          masterRefferalStatusEntity,
                        } = listItem;
                        if (listItem.providerStatusId === 3) {
                          const basicOrgData = provider.organizationEntity;
                          const fetchedOrgData = this.state.organizationDetails[
                            listItem.providerId
                          ];
                          const orgData = fetchedOrgData || basicOrgData;
                          const pictures =
                            fetchedOrgData?.organizationPictures || [];
                          const categoryColors = ["#01A7A6"];

                          // Filter service categories
                          const serviceCategories = (
                            provider?.array || []
                          ).filter((category) => {
                            const catId = category.categoryId;
                            const selectedCat =
                              totalCategoryIds?.[providerData?.categoryId];
                            const matchesFilter =
                              selectedCat?.subCategory?.includes(catId) ||
                              selectedCat?.childCategory?.includes(catId);
                            const hasValue =
                              category.value && category.value !== "";
                            return matchesFilter && hasValue;
                          });

                          return (
                            <Box
                              width={1}
                              mb={2}
                              pr={2}
                              key={index}
                              style={{
                                backgroundColor: "#fff",
                                borderRadius: "12px",
                                padding: "16px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              }}
                              className="g-image-and-content-box"
                            >
                              <Box
                                display="flex"
                                flexDirection="row"
                                alignItems="flex-start"
                                justifyContent="space-between"
                              >
                                {/* Photo Gallery - Commented out per client feedback (DP user doesn't need pictures after finalized) */}
                                {/* {pictures.length > 0 && (
                                <Box
                                  style={{
                                    position: "relative",
                                    width: "150px",
                                    height: "150px",
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    marginRight: "16px",
                                    cursor: "pointer"
                                  }}
                                  className="g-image-box"
                                  onClick={() =>
                                    this.handleImageClick(pictures, 0)
                                  }
                                >
                                  <img
                                    src={
                                      pictures[0].pictureBase64 ||
                                      pictures[0].pictureUrl
                                    }
                                    alt="Organization"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  {pictures.length > 1 && (
                                    <Box
                                      style={{
                                        position: "absolute",
                                        bottom: "8px",
                                        left: "8px",
                                        backgroundColor: "rgba(0,0,0,0.7)",
                                        color: "#fff",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {pictures.length}+ Photos
                                    </Box>
                                  )}
                                </Box>
                                )} */}

                                {/* Provider Info - Middle Left */}
                                <Box
                                  style={{ flex: 1, minWidth: 0 }}
                                  className="g-center-content-box"
                                >
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    mb={3}
                                  >
                                    {/* Org Logo */}
                                    {orgData?.organizationLogoBase64 && (
                                      <Box
                                        style={{
                                          width: 50,
                                          height: 50,
                                          borderRadius: "50%",
                                          overflow: "hidden",
                                          marginRight: 8,
                                          flexShrink: 0
                                        }}
                                      >
                                        <img
                                          src={orgData.organizationLogoBase64}
                                          alt="logo"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                          }}
                                        />
                                      </Box>
                                    )}
                                    <Box display="flex" flexDirection="column">
                                      {/* Provider Name */}
                                      <Box>
                                        <span
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "16px",
                                            color: "#01A7A6",
                                            cursor: "pointer",
                                          }}
                                          title={
                                            orgData?.orgName ||
                                            provider.providerName
                                          }
                                          onClick={() =>
                                            this.providerDetailModal({
                                              ...provider,
                                              providerId: listItem.providerId,
                                              array: provider.array,
                                              organizationEntity: provider.organizationEntity ? [provider.organizationEntity] : [],
                                              otherFilteredAddressEntities: [],
                                            })
                                          }
                                        >
                                          {orgData?.orgName ||
                                            provider.providerName}
                                        </span>
                                        <span
                                          className="infoicon-svg"
                                          style={{
                                            marginLeft: "4px",
                                            position: "relative",
                                          }}
                                        >
                                          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M9.82967 5.635C10.5662 5.635 11.1632 5.12383 11.1632 4.49328C11.1632 3.86273 10.5662 3.35156 9.82967 3.35156C9.09316 3.35156 8.49609 3.86273 8.49609 4.49328C8.49609 5.12383 9.09316 5.635 9.82967 5.635Z" fill="#01A7A6"/>
                                              <path d="M12.7577 13.5397H10.8526V7.01562H7.99495C7.74232 7.01562 7.50003 7.10155 7.3214 7.25448C7.14276 7.40742 7.0424 7.61485 7.0424 7.83114C7.0424 8.04743 7.14276 8.25486 7.3214 8.40779C7.50003 8.56073 7.74232 8.64665 7.99495 8.64665H8.94751V13.5397H7.0424C6.78977 13.5397 6.54748 13.6257 6.36884 13.7786C6.1902 13.9315 6.08984 14.139 6.08984 14.3552C6.08984 14.5715 6.1902 14.779 6.36884 14.9319C6.54748 15.0848 6.78977 15.1708 7.0424 15.1708H12.7577C13.0104 15.1708 13.2526 15.0848 13.4313 14.9319C13.6099 14.779 13.7103 14.5715 13.7103 14.3552C13.7103 14.139 13.6099 13.9315 13.4313 13.7786C13.2526 13.6257 13.0104 13.5397 12.7577 13.5397Z" fill="#01A7A6"/>
                                              <path d="M9.8836 0C7.92881 0 6.01792 0.579663 4.39257 1.66569C2.76722 2.75171 1.50041 4.29532 0.752348 6.10131C0.00428242 7.9073 -0.191446 9.89456 0.189915 11.8118C0.571276 13.729 1.5126 15.4901 2.89484 16.8724C4.27709 18.2546 6.03818 19.1959 7.95541 19.5773C9.87264 19.9586 11.8599 19.7629 13.6659 19.0149C15.4719 18.2668 17.0155 17 18.1015 15.3746C19.1875 13.7493 19.7672 11.8384 19.7672 9.8836C19.7672 7.2623 18.7259 4.74837 16.8724 2.89484C15.0188 1.0413 12.5049 0 9.8836 0ZM9.8836 18.1199C8.25461 18.1199 6.6622 17.6369 5.30774 16.7319C3.95328 15.8268 2.89761 14.5405 2.27422 13.0355C1.65084 11.5305 1.48773 9.87446 1.80553 8.27677C2.12333 6.67908 2.90776 5.2115 4.05964 4.05963C5.21151 2.90776 6.67908 2.12333 8.27677 1.80553C9.87446 1.48772 11.5305 1.65083 13.0355 2.27422C14.5405 2.89761 15.8268 3.95328 16.7319 5.30774C17.6369 6.66219 18.1199 8.25461 18.1199 9.8836C18.1199 10.9652 17.9069 12.0362 17.493 13.0355C17.0791 14.0348 16.4724 14.9427 15.7076 15.7076C14.9428 16.4724 14.0348 17.0791 13.0355 17.493C12.0362 17.9069 10.9652 18.1199 9.8836 18.1199Z" fill="#01A7A6"/>
                                            </svg>
                                        </span>
                                      </Box>

                                      {/* Contact Person & Phone */}
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        style={{
                                          gap: "16px",
                                          fontSize: "13px",
                                          color: "#666"
                                        }}
                                      >
                                        <Box display="flex" alignItems="center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            viewBox="0 0 13.312 15.214"
                                            style={{ marginRight: "4px" }}
                                          >
                                            <path
                                              d="M6.656,7.607a3.8,3.8,0,1,0-3.8-3.8A3.8,3.8,0,0,0,6.656,7.607Zm2.662.951h-.5a5.172,5.172,0,0,1-4.332,0h-.5A4,4,0,0,0,0,12.551v1.236a1.427,1.427,0,0,0,1.426,1.426H11.886a1.427,1.427,0,0,0,1.426-1.426V12.551A4,4,0,0,0,9.318,8.558Z"
                                              fill="#01a7a6"
                                            />
                                          </svg>
                                          <span>
                                            {provider.user.firstName}{" "}
                                            {provider.user.lastName}
                                          </span>
                                        </Box>
                                        <Box display="flex" alignItems="center">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            viewBox="0 0 14.609 14.608"
                                            style={{ marginRight: "4px" }}
                                          >
                                            <path
                                              d="M5.94,9.324a12.228,12.228,0,0,0,5.347,5.344l1.785-1.788a.813.813,0,0,1,.825-.2,9.326,9.326,0,0,0,2.9.461.811.811,0,0,1,.812.812v2.84a.811.811,0,0,1-.812.812A13.8,13.8,0,0,1,3,3.81.811.811,0,0,1,3.81,3h2.84a.811.811,0,0,1,.812.812,9.326,9.326,0,0,0,.461,2.9.811.811,0,0,1-.2.824Z"
                                              transform="translate(-2.999 -2.998)"
                                              fill="#01a7a6"
                                            />
                                          </svg>
                                          <span>
                                            {provider.user.phoneNumber
                                              ? "(" +
                                                provider.user.phoneNumber.match(
                                                  /(\d{3})(\d{3})(\d{4})/,
                                                )?.[1] +
                                                ") " +
                                                provider.user.phoneNumber.match(
                                                  /(\d{3})(\d{3})(\d{4})/,
                                                )?.[2] +
                                                "-" +
                                                provider.user.phoneNumber.match(
                                                  /(\d{3})(\d{3})(\d{4})/,
                                                )?.[3]
                                              : "N/A"}
                                          </span>
                                        </Box>
                                      </Box>
                                    </Box>
                                  </Box>

                                  {/* Service Categories - Inline Cards */}
                                  {serviceCategories.length > 0 && (
                                    <Box
                                      display="flex"
                                      flexWrap="nowrap"
                                      style={{ gap: "8px" }}
                                    >
                                      {serviceCategories
                                        .slice(0, 3)
                                        .map((category, catIndex) => {
                                          const color =
                                            categoryColors[
                                              catIndex % categoryColors.length
                                            ];
                                          return (
                                            <Box
                                              key={category.id || catIndex}
                                              style={{
                                                color: "rgb(255, 255, 255)",
                                                borderRadius: "16px",
                                                padding: "0px 0px",
                                                textAlign: "center",
                                                minWidth: "150px",
                                                boxShadow: "0px 0px 7.7px 0px #0000004D"
                                              }}
                                              className="g-category-box"
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: color,
                                                  fontSize: "12px",
                                                  fontWeight: "500",
                                                  lineHeight: "1",
                                                  whiteSpace: "nowrap",
                                                  marginBottom: "2px",
                                                  padding: "6px 12px",
                                                  borderTopLeftRadius: "16px",
                                                  borderTopRightRadius: "16px",
                                                }}
                                              >
                                                {category.masterCategories
                                                  ?.categoryValue ||
                                                  category.categoryName}
                                              </div>
                                              <div
                                                style={{
                                                  fontSize: "24px",
                                                  fontWeight: "bold",
                                                  lineHeight: "1.2",
                                                  backgroundColor: "#FFF",
                                                  color: color,
                                                  borderBottomLeftRadius: "16px",
                                                  borderBottomRightRadius: "16px",
                                                  padding: "10px 0px 6px 0px",
                                                }}
                                              >
                                                ${category.value}
                                              </div>
                                            </Box>
                                          );
                                        })}
                                    </Box>
                                  )}
                                </Box>

                                {/* Right Side - Timestamp & Download Brochure */}
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  alignItems="flex-end"
                                  justifyContent={"space-between"}
                                  style={{ marginLeft: "auto", flexShrink: 0 }}
                                  className="g-right-content-box"
                                >
                                  <Box
                                    style={{
                                      textAlign: "right",
                                      marginBottom: "12px"
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        color: "#000"
                                      }}
                                    >
                                      Referral Finalized
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        color: "#000"
                                      }}
                                    >
                                      {this.dateUtility.format(
                                        new Date(listItem.formattedUpdatedDate),
                                        "MM/dd/yyyy HH:mm:ss",
                                      )}
                                    </div>
                                  </Box>

                                  {/* Download Brochure Button */}
                                  {orgData?.organizationBrochureBase64 && (
                                    <button
                                      onClick={() =>
                                        this.handleDownloadBrochure(orgData)
                                      }
                                      style={{
                                        backgroundColor: "#F07DA8",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        padding: "8px 16px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        fontSize: "14px",
                                        marginTop: "50px"
                                      }}
                                      className="g-btn1"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                      >
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
                                      </svg>
                                      Download Brochure
                                    </button>
                                  )}

                                  {/* Fax Status */}
                                  {providerData.faxStatus &&
                                    providerData.faxStatus !== "" &&
                                    !provider.registeredStatus && (
                                      <div
                                        style={{
                                          marginTop: "8px",
                                          fontSize: "12px",
                                          color: "#666",
                                        }}
                                      >
                                        Fax: {providerData.faxStatus}
                                      </div>
                                    )}
                                </Box>
                              </Box>
                            </Box>
                          );
                        }
                      })
                    ) : (
                      <div className="no-found-text">
                        Accepted Provider Not Found
                      </div>
                    )}
                    {refferalProviderEntity && refferalProviderEntity.length
                      ? refferalProviderEntity.map((listItem, index) => {
                          const { provider } = listItem;

                          if (
                            listItem.providerStatusId === 3 &&
                            provider.registeredStatus
                          ) {
                            return (
                              <div
                                key={index}
                                className="comments-section match-height-table g-comment-section"
                              >
                                <div className="heading">Comments</div>

                                {this.state.providerData
                                  .refferalProviderComment &&
                                this.state.providerData.refferalProviderComment
                                  .length
                                  ? null
                                  : null}

                                {this.state.providerData
                                  .refferalProviderEntity?.[0] &&
                                this.state.providerData
                                  .refferalPatientEntity?.[0] ? (
                                  <ChatComment
                                    referralId={
                                      this.state.providerData
                                        .refferalProviderEntity[0].refferalId
                                    }
                                    receiverId={this.state.receiverId}
                                    patientId={this.state.patientId}
                                    prelimComment={
                                      this.state.providerData
                                        ?.refferalProviderEntity?.[0]
                                        ?.refferalProviderComment?.length
                                        ? this.state.providerData
                                            .refferalProviderEntity[0]
                                            .refferalProviderComment
                                        : []
                                    }
                                  />
                                ) : null}
                              </div>
                            );
                          }
                          return null; // Ensures map() doesn't break
                        })
                      : null}
                  </Scrollbars>
                </div>
              </Box>
            </Box>
          ) : loading ? (
            <Box pr={3} pl={2} width={1} display="flex" justifyContent="center">
              <CircularProgress size={24} className="CircularProgress-CSS " />
            </Box>
          ) : (
            <div className="no-found-text">Providers Not Available</div>
          )}
        </Box>

      </>
    );
  }
}

export const FinalizedProviderTabPanel = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinalizedProviderTabPanelClass);
export default FinalizedProviderTabPanel;
